<template>
  <div class="p-1 file-uploader">
    <vue-clip  ref="vc" :options="uploadOptions" :on-complete="onComplete"
              :on-max-files="onMaxFiles">

      <template slot="clip-uploader-action">
        <div>
          <div class="dz-message m-2 p-1 drop-zone"><p class="card-text">
            Click or drag here </p></div>
        </div>
      </template>


      <template slot="clip-uploader-body" slot-scope="props">
        <div >
          <div
               v-for="(file, i) in props.files.filter(function(f){return !f.customAttributes.ignore})">
            <b-row>
              <b-col>
                <b-progress :variant="file.customAttributes.error ? 'danger' : 'success' " :value="file.progress" :max="100" show-progress :animated="file.progress<100">
                  <icon v-if="file.progress==100 || file.errorMessage" @click.native="removeFile(file)" class="close-file"
                        name="times"></icon>
                </b-progress>
              </b-col>
              <b-col>
                <div>{{file.name}}</div>
              </b-col>
            </b-row>
            <b-row v-if="file.errorMessage">
              <b-col>
                <span class="text-danger">{{file.errorMessage}}</span>
              </b-col>
            </b-row>


            <!--{{ file.name }} {{ file.status }} {{ file.customAttributes.id }}-->


          </div>
        </div>
      </template>
    </vue-clip>
  </div>
</template>

<script>
  import 'vue-awesome/icons/times'

  export default {
    name: 'FileUploader',
    props: {
      value: {
        default: null
      },
      ext: {
        default: undefined
      },
      countLimit: {
        default: 1
      },
      sizeLimit: {
        default: 40
      },
      multi: {
        default: false
      },
      scriptId: {
        default: 0
      },
      validFn: {
        default: undefined,
        type: Function
      }
    },
    mounted () {
      this.$bus.$on("uploader-clean", (id) => {
        console.log("clean "+id)
        if (id === this.scriptId) {
          this.clean()
        }
      })
    },
    methods: {
      clean () {
        this.$refs.vc.files && this.$refs.vc.files.forEach((file, i) => {
          this.removeFile(file)
        })

        this.paths.forEach((p, i) => {
          this.paths.splice(i, 1)
        })
      },
      onMaxFiles (file) {
        file.addAttribute('ignore', true)
      },
      removeFile (file) {
        this.$refs.vc.removeFile(file)
        let index = this.$refs.vc.files.indexOf(file)
        if (index > -1) {
          this.$refs.vc.files.splice(index, 1)
        }

        if (file.customAttributes.path) {
          index = this.paths.indexOf(file.customAttributes.path)
          if (index > -1 ) {
            this.paths.splice(index,1)
          }
        }
        this.$emit('input', this.paths.join(','))
      },
      onComplete (file, status, xhr) {
        if (!xhr) {
          return
        }

        try {
          let res = JSON.parse(xhr.response)
          let path = res.paths[0]
          this.paths.push(path)
        } catch (e) {
          file.addAttribute('error', true)
        }
        console.log(this.paths.join(','))
        this.$emit('input', this.paths.join(','))
      }
    },
    data () {
      return {
        paths: [],
        uploadOptions: {
          uploadMultiple: this.multi,
          url: '/api/uploads/add_upload',
          paramName: 'file',
          acceptedFiles: this.ext ? {
            extensions: this.ext
          } : undefined,
          maxFilesize: {
            limit: this.sizeLimit,
            message: `File size limit exceeded (${this.sizeLimit}MB)`
          },
          maxFiles: {
            limit: this.countLimit,
            message: `Possible to upload at maximum ${this.countLimit} files`
          },
          accept: this.validFn
        }
      }
    }
  }
</script>

<style lang="scss">
.file-uploader .drop-zone{
  border: 1px dashed black !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/FileUploader.vue